import { API_URL } from '../../app/apiConfig';

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  const headers = { 'content-type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export function createOrder(order) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/orders`, {
        method: 'POST',
        body: JSON.stringify(order),
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await response.json();
      
      if (!response.ok) {
        reject(data);
      } else {
        resolve({ data });
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function updateOrder(order) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/orders/` + order.id, {
        method: 'PATCH',
        body: JSON.stringify(order),
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await response.json();
      
      if (!response.ok) {
        reject(data);
      } else {
        resolve({ data });
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function fetchAllOrders(sort, pagination) {
  let queryString = '';

  for (let key in sort) {
    queryString += `${key}=${sort[key]}&`;
  }
  for (let key in pagination) {
    queryString += `${key}=${pagination[key]}&`;
  }

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${API_URL}/api/orders?` + queryString,
        { 
          headers: getAuthHeaders(),
          credentials: 'include' 
        }
      );
      const data = await response.json();
      
      if (!response.ok) {
        console.error('❌ fetchAllOrders failed:', data);
        return reject(data);
      }

      const totalOrders = response.headers.get('X-Total-Count');
      resolve({ 
        data: { 
          orders: Array.isArray(data) ? data : [], 
          totalOrders: totalOrders ? +totalOrders : (Array.isArray(data) ? data.length : 0) 
        } 
      });
    } catch (error) {
      console.error('❌ fetchAllOrders network error:', error);
      reject(error);
    }
  });
}
